import currencyMap from './currencyMap'

const currencySymbol = (code: string) => {
  const fomattedCode = code.toUpperCase()
  return currencyMap[fomattedCode]
}

export default currencySymbol
